export enum UdexMessageStripDesign {
  Information = "Information",
  Positive = "Positive",
  Negative = "Negative",
  Warning = "Warning",
  Action = "Action",
}

export enum UdexMessageStripStatusType {
  Icon = "Icon",
  Text = "Text",
  None = "None",
}
